import React, { useEffect, useState } from 'react';
import { Box, Typography, Paper, Button, Alert, CircularProgress, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import AdminLayout from '../../components/admin/AdminLayout';
import axios from 'axios';
import { useAuth } from '../../contexts/AuthContext';

function ReportManagementPage() {
    const { token } = useAuth();
    const [reports, setReports] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [toast, setToast] = useState('');

    const fetchReports = async () => {
        setLoading(true);
        try {
            const { data } = await axios.get('/api/admin/reports', {
                headers: { Authorization: `Bearer ${token}` }
            });
            setReports(data);
        } catch (err) {
            setError('Failed to fetch reported items.');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchReports();
    }, [token]);

    const handleDeleteItem = async (itemId) => {
        if (window.confirm("Are you sure you want to delete this item permanently?")) {
            try {
                await axios.delete(`/api/admin/items/${itemId}`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                setToast('Item deleted successfully.');
                fetchReports();
            } catch (err) {
                setError('Failed to delete item.');
            }
        }
    };

    const handleDismissReport = async (reportId) => {
        if (window.confirm("Are you sure you want to dismiss this report?")) {
            try {
                await axios.delete(`/api/admin/reports/${reportId}`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                setToast('Report dismissed.');
                fetchReports();
            } catch (err) {
                setError('Failed to dismiss report.');
            }
        }
    };

    if (loading) return <CircularProgress />;

    return (
        <AdminLayout>
            <Typography variant="h4" gutterBottom>Report Management</Typography>
            {toast && <Alert severity="success" sx={{ mb: 2 }}>{toast}</Alert>}
            {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
            
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Item Name</TableCell>
                            <TableCell>Reason</TableCell>
                            <TableCell>Reported By</TableCell>
                            <TableCell>Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {reports.map((report) => (
                            <TableRow key={report._id}>
                                <TableCell>{report.itemDetails?.itemName}</TableCell>
                                <TableCell>{report.reason}</TableCell>
                                <TableCell>{report.reporterInfo?.username}</TableCell>
                                <TableCell>
                                    <Button size="small" onClick={() => handleDismissReport(report._id)}>Dismiss</Button>
                                    <Button size="small" color="error" onClick={() => handleDeleteItem(report.itemDetails?._id)}>Delete Item</Button>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </AdminLayout>
    );
}

export default ReportManagementPage;
